import { cn } from '@utils/cn';

import { Icon } from '@ui-component-library/components/Icon';
import { Text } from '@ui-component-library/components/Text';

import { wrapperClasses } from './Chip.styles';
import type { ChipProps } from './Chip.types';

export const Chip = ({ className, icon, label, onClick }: ChipProps) => {
  return (
    <div className={cn(wrapperClasses(), className)} onClick={onClick}>
      {icon && <Icon name={icon} size="small" />}
      <Text variant="text-xs/leading-normal/medium">{label}</Text>
    </div>
  );
};
